
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { CompetenceData } from '../../data/competencesData';

interface CompetenceHeaderProps {
  competence: CompetenceData;
}

const CompetenceHeader = ({ competence }: CompetenceHeaderProps) => {
  const IconComponent = competence.icon;

  return (
    <>
      <Link 
        to="/expertise" 
        className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-8 transition-colors"
      >
        <ArrowLeft size={20} />
        Retour à l'expertise
      </Link>

      <div className="text-center mb-12">
        <div className="bg-gradient-to-r from-blue-600 to-navy-700 p-6 rounded-xl w-20 h-20 mx-auto mb-6">
          <IconComponent className="text-white mx-auto" size={32} />
        </div>
        <h1 className="text-4xl font-light text-navy-900 mb-4">{competence.title}</h1>
        <p className="text-xl text-navy-600 font-light">{competence.description}</p>
      </div>
    </>
  );
};

export default CompetenceHeader;
